import React from 'react'

export default function MayaButton(props) {
  return (
    <>
        <button onClick={()=>{props.onClick()}} className='bg-maya-orange/[.3] px-2 py-1 text-lg rounded-xl text-maya-orange hover:text-white hover:bg-maya-orange duration-300'>{props.children}</button>
    </>
  )
}
